import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import {
  PaygapSettingsDto,
  UpdatePaygapSettingsDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_PAYGAP } from "../domain";
import { ACTION_GET_PAYGAP_SETTINGS } from "../GetPaygapSettings/useGetPaygapSettings";

import { paygapApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_UPDATE_PAYGAP_SETTINGS = "UPDATE_PAYGAP_SETTINGS";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const updatePaygapSettings = async (
  dto: UpdatePaygapSettingsDto,
): Promise<PaygapSettingsDto> => {
  const response = await paygapApi.paygapControllerUpdateSettings(dto);

  return response.data;
};

export const useUpdatePaygapSettings = (
  user: UserProfileDto | null,
): {
  updateSettings: UseMutateFunction<
    PaygapSettingsDto,
    Error,
    UpdatePaygapSettingsDto,
    unknown
  >;
  updateSettingsEnabled: boolean;
  isPendingUpdateSettings: boolean;
  isSuccessUpdateSettings: boolean;
  updateSettingsError: Error | null;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending, error } = useMutation({
    mutationKey: [DOMAIN_PAYGAP, ACTION_UPDATE_PAYGAP_SETTINGS],
    mutationFn: enabled ? updatePaygapSettings : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_PAYGAP, ACTION_GET_PAYGAP_SETTINGS],
      });
    },
  });

  return {
    updateSettings: mutate,
    updateSettingsEnabled: enabled,
    isPendingUpdateSettings: isPending,
    isSuccessUpdateSettings: isSuccess,
    updateSettingsError: error,
  };
};
